<% if (booking.physical_address) { %>
  <div class="item-icon --address"></div>
  <div class="item-content">
    <% if (AppointmentBooking.config.show_address_nickname_in_wizard_header) { %>
      <div class="address-nickname" translate="no">
        <%- booking.address.address_nickname_with_fallback %>
      </div>
    <% } %>
    <div class="address-first-line" translate="no">
      <%- booking.address.street_address %>
    </div>
    <div class="address-second-line" translate="no">
      <%- booking.address.city %>, <%- booking.address.state %> <%- booking.address.zip_code %>
    </div>
  </div>
<% } else { %>
  <div class="item-icon <%- booking.appointment_slot.visit_type_category %>-visit"></div>
  <div class="item-content">
    <div class="address-first-line">
      <strong><%= I18n.header.virtual_visit %></strong>
    </div>
    <div class="address-second-line">
      <%- booking.appointment_slot.visit_type_channel %>
    </div>
  </div>
<% } %>
